import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            welcome: "Welcome",
            invoice: "Invoice",
        },
    },
    es: {
        translation: {
            welcome: "Bienvenido",
            invoice: "Factura",
        },
    },
    // Add more languages here
};

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false, // React already escapes by default
    },
});

export default i18n;
